export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	requestUniversityVerification(state: any, user_university_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/user-universities/${user_university_uuid}/request-verification`)
				.then((res) => resolve(res))
				.catch((err) => reject(err));
		});
	},

	uploadUniversityDocument(state: any, payload: any) {
		const { user_university_uuid, data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/user-universities/${user_university_uuid}/documents`, data)
				.then((res) => resolve(res))
				.catch((err) => reject(err));
		});
	},
};
